import {
  Box,
  IconButton,
  Stack,
  Slide,
  Icon,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Tooltip,
  Chip
} from 'investira.react.components';

import { formats, validators } from 'investira.sdk';
import { CARTEIRA_TIPO } from '../../../../../enums';

const commonColumns = {
  pessoa: { key: 'pessoa', label: '', align: 'left' },
  pessoa_fantasia: { key: 'pessoa_fantasia', label: 'Fundo', align: 'left' },
  ativo: { key: 'ativo', label: 'Ativo', align: 'left' },
  ticker: { key: 'ticker', label: 'Ticker', align: 'left' },
  cnpj: { key: 'cnpj', label: 'CNPJ', align: 'left' },
  isin: { key: 'isin', label: 'ISIN', align: 'left' },
  emissor: { key: 'emissor', label: 'Emissor', align: 'left' },
  financeiro: { key: 'financeiro', label: 'Financeiro', align: 'right' },
  vencimento: { key: 'vencimento', label: 'Vencimento', align: 'left' },
  codigo: { key: 'codigo', label: 'Código', align: 'left' },
  ativo_tipo: { key: 'ativo_tipo', label: 'Tipo de Ativo', align: 'left' },
  serie: { key: 'serie', label: 'Série', align: 'left' },
  curva: { key: 'curva_id', label: 'Curva', align: 'left' },
  carteira: { key: 'carteira', label: 'Carteira', align: 'left' },
  carteira_seuid: {
    key: 'carteira_seuid',
    label: 'Carteira SeuID',
    align: 'left'
  },
  carteira_tipo_id: { key: 'carteira_tipo_id', label: 'Tipo', align: 'left' },
  data_posicao: { key: 'data', label: 'Última Posição', align: 'left' },
  aberta: { key: 'aberta', label: 'Posição', align: 'center' },
  data_sync: { key: 'data_sync', label: '', align: 'left' },
  recurso_garantidor: {
    key: 'recurso_garantidor',
    label: 'Recurso Garantidor',
    align: 'right',
    getValue: item => item.contabil?.recurso_garantidor || null
  }
};

const columns = [
  commonColumns.carteira,
  commonColumns.carteira_seuid,
  commonColumns.carteira_tipo_id,
  commonColumns.data_posicao,
  commonColumns.aberta,
  commonColumns.data_sync,
  commonColumns.recurso_garantidor
];

const ConsolidacaoDetalhe = props => {
  const { data } = props;

  return (
    <Box
      sx={{
        width: '100%',
        mx: 'auto',
        position: 'relative',
        overflow: 'hidden',
        pb: 2,
        transition: 'all 0.1s ease-in-out'
      }}>
      <Slide direction="right" in={true} mountOnEnter unmountOnExit>
        <Stack sx={{ height: '100%' }}>
          <TableContainer
            id="table-container"
            sx={{
              overflow: 'auto'
            }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map(column => (
                    <TableCell key={column.key} align={column.align}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.request_metadata?.carteiras &&
                  data.request_metadata.carteiras
                    .sort((a, b) => {
                      // Aplica ordenação pela data mais recente
                      return new Date(b.data) - new Date(a.data);
                    })
                    .map((xItem, xIndex) => {
                      return (
                        <TableRow key={xItem.carteira_seuid}>
                          {columns.map(column => {
                            const value = xItem[column.key];

                            if (column.key === 'carteira_tipo_id') {
                              return (
                                <TableCell
                                  key={column.key}
                                  sx={{
                                    width: '24px',
                                    whiteSpace: 'nowrap'
                                  }}
                                  align="right">
                                  {CARTEIRA_TIPO[value].label}
                                </TableCell>
                              );
                            }

                            if (column.key === 'recurso_garantidor') {
                              const value = column.getValue(xItem);
                              const hasRecursos = !validators.isNull(value);
                              return (
                                <TableCell
                                  key={column.key}
                                  sx={{
                                    whiteSpace: 'nowrap'
                                  }}
                                  align="right">
                                  {!hasRecursos ? (
                                    <Chip
                                      label="Ausente"
                                      variant="outlined"
                                      color="error"
                                      size="small"
                                    />
                                  ) : (
                                    formats.formatNumber(value || 0, 2, true)
                                  )}
                                </TableCell>
                              );
                            }

                            if (column.key === 'aberta') {
                              const title = validators.isNull(value)
                                ? 'Posição Ausente'
                                : value
                                ? 'Posição Aberta'
                                : 'Posição Fechada';

                              const color = validators.isNull(value)
                                ? 'error'
                                : value
                                ? 'warning'
                                : 'primary';

                              const iconName = validators.isNull(value)
                                ? 'warning'
                                : value
                                ? 'box_3d_open'
                                : 'box_3d';

                              return (
                                <TableCell
                                  key={column.key}
                                  sx={{
                                    width: '24px',
                                    whiteSpace: 'nowrap'
                                  }}
                                  align="center">
                                  <Tooltip title={title}>
                                    <IconButton color={color} size="small">
                                      <Icon iconName={iconName} size={18} />
                                    </IconButton>
                                  </Tooltip>
                                </TableCell>
                              );
                            }

                            if (column.key === 'data_sync') {
                              return (
                                <TableCell
                                  key={column.key}
                                  sx={{
                                    width: '24px',
                                    whiteSpace: 'nowrap'
                                  }}
                                  align="right">
                                  {!validators.isNull(value) && !value && (
                                    <Tooltip title="A data da posição disponível desta carteira, não está em sincronia com a data selecionada do portfólio.">
                                      <IconButton color="warning" size="small">
                                        <Icon iconName={'warning'} size={18} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </TableCell>
                              );
                            }

                            const isDate = [
                              'operacao_data',
                              'emissao',
                              'vencimento',
                              'data'
                            ].includes(column.key);

                            const isNumber = ['quantidade', 'pu', 'financeiro', 'taxa'].includes(
                              column.key
                            );

                            return (
                              <TableCell key={column.key} align={column.align}>
                                {isNumber && value
                                  ? formats.formatNumber(value, 2, true)
                                  : isDate
                                  ? value
                                    ? formats.formatDateCustom(value, 'DD/MM/YYYY')
                                    : '--'
                                  : value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Slide>
    </Box>
  );
};

export default ConsolidacaoDetalhe;
